const adminContactsRouter = [
  {
    path: '/admin/contacts',
    name: 'AdminContactsIndex',
    component: () => import('@/views/admin/contacts/index')
  },
  {
    path: '/admin/contacts/create',
    name: 'AdminContactsCreate',
    component: () => import('@/views/admin/contacts/create')
  },
  {
    path: '/admin/contacts/edit',
    name: 'AdminContactsEdit',
    component: () => import('@/views/admin/contacts/edit')
  },
  {
    path: '/admin/contacts/control',
    name: 'AdminContactsControl',
    component: () => import('@/views/admin/contacts/control')
  },
  {
    path: '/admin/contacts/vip',
    name: 'AdminContactsVip',
    component: () => import('@/views/admin/contacts/vip')
  },
  {
    path: '/admin/contacts/member/index',
    name: 'AdminContactsMemberIndex',
    component: () => import('@/views/admin/contacts/member/index')
  },
  {
    path: '/admin/contacts/news/index',
    name: 'AdminContactsNewsIndex',
    component: () => import('@/views/admin/contacts/news/index')
  },
  {
    path: '/admin/contacts/link',
    name: 'AdminContactsLink',
    component: () => import('@/views/admin/contacts/link')
  },
  {
    path: '/admin/contacts/custom',
    name: 'AdminContactsCustom',
    component: () => import('@/views/admin/contacts/custom')
  }
]

export default adminContactsRouter



// WEBPACK FOOTER //
// ./src/router/modules/admin/contacts.js